import { Content, Header, Page } from '@backstage/core-components';
import { HomePageRecentlyVisited, HomePageStarredEntities, WelcomeTitle } from '@backstage/plugin-home';
import { Grid } from '@material-ui/core';
import React from 'react';

export const HomePage = () => {
    return (
        <Page themeId="home">
            <Header title={<WelcomeTitle language={['English']} />} pageTitleOverride="Home" />
            <Content>
                <Grid container justifyContent="center" spacing={6}>
                    <Grid container item xs={12}>
                        <Grid item xs={12} md={6}>
                            <HomePageStarredEntities />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <HomePageRecentlyVisited />
                        </Grid>
                    </Grid>
                </Grid>
            </Content>
        </Page>
    );
}
